import apiService from '@sonifi/wb-core/services/api.service';
import {
  setExpandedRow,
  setTablePagination,
} from '@sonifi/wb-widget/store/tableConfig/tableConfigSlice';
import { TABLE_KEYS } from '@sonifi/wb-widget/store/tableConfig/tableConfigConstants';
import { LOADING_STATUS } from '@sonifi/wb-core/common/Constants';
import { ENDPOINTS } from '@sonifi/wb-core/services/endpointsConstants';
import { buildApiUri, parseQueryParams } from '@sonifi/wb-core/utils/parseHelper';
import configurationService from '@sonifi/wb-core/services/configuration.service';
import oauthService from '@sonifi/wb-login/services/oauth.service';
import {
  setLoadingGuestRequestOrder,
  setLoadingGuestRequestOrders,
  setOrder,
  setOrders,
} from '../../store/orders/guestRequestOrdersSlice';

const getOrderSourceLabel = (order) =>
  order.source === 'STAYCONNECT' ? 'Mobile' : 'TV';

export const getGuestRequestOrders =
  ({
    page = 1,
    pageSize = 100,
    query,
    sortBy = 'created',
    sortDir = 'desc',
  } = {}) =>
  async (dispatch, getState) => {
    const {
      groups: { selectedGroup },
    } = getState();

    const params = {
      group: selectedGroup.uri,
      page,
      _query: query,
      rpp: pageSize,
      _order_by: `${sortDir === 'desc' ? '-' : ''}${sortBy}`,
    };
    try {
      dispatch(setLoadingGuestRequestOrders(LOADING_STATUS.loading));
      const url = `${ENDPOINTS.SERVICE_ORDERS}?${parseQueryParams(params)}`;
      const res = await apiService.get(url);
      const orders = res.data?.objects || [];
      dispatch(
        setTablePagination({
          page,
          pageSize,
          query,
          sortBy,
          sortDir,
          total: res.data.total,
          tableKey: TABLE_KEYS.guestRequestOrders,
        }),
      );

      const ordersMapped = orders.map((o) => ({
        ...o,
        issue: res.data._embedded[o.service_issues[0].service_issue],
        orderSource: getOrderSourceLabel(o),
      }));

      await Promise.all([
        dispatch(setOrders({ orders: ordersMapped })),
        dispatch(setLoadingGuestRequestOrders(LOADING_STATUS.success)),
      ]);
    } catch (error) {
      dispatch(setLoadingGuestRequestOrders(LOADING_STATUS.error));
    }
  };

export const getOrderById = (id) => async (dispatch) => {
  try {
    dispatch(setLoadingGuestRequestOrder(LOADING_STATUS.loading));
    dispatch(setOrder({ order: null }));
    const url = `${ENDPOINTS.SERVICE_ORDERS}/${id}`;
    const res = await apiService.get(url);
    const orderRes = res.data;
    const issueData = {
      options: res.data._embedded[
        orderRes.service_issues[0].service_issue
      ].options.map((op, index) => ({
        ...op,
        optionDetail: Array.isArray(op?.options)
          ? op.options[orderRes.service_issues[0].options[index]]
          : orderRes.service_issues[0].options[index],
      })),
    };
    const order = {
      ...orderRes,
      group: res.data._embedded[orderRes.group],
      issue: res.data._embedded[orderRes.service_issues[0].service_issue],
      orderSource: getOrderSourceLabel(orderRes),
      issueOptions: issueData.options,
    };

    await Promise.all([
      dispatch(setOrder({ order })),
      dispatch(setLoadingGuestRequestOrder(LOADING_STATUS.success)),
    ]);
  } catch (error) {
    console.error(error);
    dispatch(setLoadingGuestRequestOrder(LOADING_STATUS.error));
  }
};

export const exportOrdersCsv = (groupId) => {
  const oauthCredentials = configurationService.get('oauthCredentials');
  if (oauthCredentials.resourceOwner) {
    const base = configurationService.get('apiUri');
    const options = oauthCredentials;
    options.params = { rpp: -1 };
    const exportLink = oauthService.buildOAuthUri(
      'GET',
      buildApiUri(base, 'groups', groupId, 'service_orders.csv'),
      false,
      options,
    );
    window.open(exportLink, '_blank');
  }
};

export const initRowExpanded = (id) => async (dispatch, getState) => {
  const {
    guestRequestOrders: { ordersFiltered },
  } = getState();
  const orderIndex = ordersFiltered.findIndex((o) => o.id === parseInt(id));

  dispatch(
    setExpandedRow({
      expanded: orderIndex !== -1 ? { [orderIndex]: true } : {},
      tableKey: TABLE_KEYS.guestRequestOrders,
    }),
  );
};
